import { createContext, RefObject } from 'react';

import { CloseDialogFn } from './types';

export const CloseDialogContext = createContext<CloseDialogFn<unknown>>(
  () => {}
);

export const DialogResultContext = createContext<RefObject<unknown>>({
  current: undefined,
});
